export class MetricTimeseries {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "series",
            "baseName": "series",
            "type": "string",
            "format": ""
        },
        {
            "name": "startTs",
            "baseName": "startTs",
            "type": "number",
            "format": ""
        },
        {
            "name": "endTs",
            "baseName": "endTs",
            "type": "number",
            "format": ""
        },
        {
            "name": "stepSeconds",
            "baseName": "stepSeconds",
            "type": "number",
            "format": ""
        },
        {
            "name": "points",
            "baseName": "points",
            "type": "Array<MetricTimeseriesPoint>",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return MetricTimeseries.attributeTypeMap;
    }
    constructor() {
    }
}
